import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectProductData } from "../../../app/features/ProductSlice";
import { useNavigate, useParams } from "react-router";
import { Col, Row } from "react-bootstrap";
import { setPageTitle } from "../../../app/features/DataSlice";
import PurchaseSummary from "../../../components/HeliorPlan/PurchaseSummary";
import HOneConfirmCard from "../../../components/HeliorOne/HOneConfirmCard";
import BankDetailCard from "../../../components/paymentMethods/BankDetailCard";
import { BANK_PAYMENT_METHODS } from "../../../Constants";

const pageTitle = "purchaseConfirmation";

const StorePurchaseConfirmation = () => {
  const navigate = useNavigate();
  const purchaseData = useSelector(selectProductData);

  const { lang, planType } = useParams();
  if (!purchaseData || Object.keys(purchaseData).length === 0) {
    navigate(`/${lang}/products`);
  }
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(setPageTitle(t(`${pageTitle}`)));
    // eslint-disable-next-line
  }, []);
  return (
    <Row className="my-5">
      <Col md="6">
        {BANK_PAYMENT_METHODS.includes(purchaseData?.paymentMethod) && (
          <BankDetailCard planId={purchaseData?.planId} />
        )}
      </Col>
      {planType.includes("plan") && (
        <Col md="6">
          <PurchaseSummary paymentData={purchaseData} />
        </Col>
      )}
      {planType.includes("one") && (
        <Col md="6">
          <HOneConfirmCard paymentData={purchaseData} />
        </Col>
      )}
    </Row>
  );
};

export default StorePurchaseConfirmation;
